import { render, staticRenderFns } from "./ViewResellerComponent.vue?vue&type=template&id=34bda240"
import script from "./ViewResellerComponent.vue?vue&type=script&lang=js"
export * from "./ViewResellerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports